import React, { Fragment } from 'react';
import {
  translate,
  Datagrid,
  Edit,
  Create,
  EditButton,
  List,
  SimpleForm,
  TextField,
  TextInput,
  // NumberField,
  NumberInput,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  ReferenceArrayInput,
  SelectArrayInput,
  ReferenceArrayField,
  SingleFieldList,
  ChipField,
  Filter,
  BulkDeleteButton,
  BooleanInput,
  CreateButton,
  DateField,
} from 'react-admin';
import Toolbar from '@material-ui/core/Toolbar';
import withStyles from '@material-ui/core/styles/withStyles';
import BookmarkIcon from '@material-ui/icons/Bookmark';
// import DateInput from '../../../../components/DateInput';

import LinkToList from './LinkToList';
// import CodeType from '../codeType';
// import DeliveryType from '../deliveryType';
// import OrderStatus from '../orderStatus';
import InputP from '../inputP';
import MarkingType from '../markingType';
import SendOrderButton from './SendOrderButton';
// import CreateMrkButton from './CreateMrkButton';
import resourceLocales from './locales';
import resourceConfig from './config';
import directionType from '../directionType';
import docStatus from '../docStatus';
import docType from '../docType';
import docStatusSystem from '../docStatusSystem';
import markingType from '../markingType';
import DateInput from '../../../../components/DateInput';
import markingStatus from '../markingStatus';
import docLinkType from '../docLinkType';
import documentRowStyle from '../../../../utils/ui/documentRowStyle';
import errorModel from '../errorModel';
import objectSendModel from '../objectSendModel';
import productionTypeInput from '../productionTypeInput';
import documentImport from '../documentImport';
// import inputCheck from '../inputCheck';
import exporter from '../../../../utils/exporter';
import docUpdate from '../docUpdate';
import docCheckStatus from '../docCheckStatus';
import PostPagination from '../../../../utils/pagination';
import ExportDocButton from '../docH/ExportDocButton';

const ResourceIcon = BookmarkIcon;

const listStyles = {};

const ResourceBulkActionButtons = (props) => (
  <Fragment>
    <docUpdate.Button {...props} bulk docType={'INPUT'} />
    <BulkDeleteButton {...props} />
  </Fragment>
);

const ResourceListFilter = (props) => (
  <Filter {...props}>
    <TextInput source={'ids'} />
    <TextInput source={'docnum'} />
    <TextInput source={'error'} />
    <TextInput source={'guid'} />
    <docCheckStatus.FilterInput source={'checkStatus'} />
    <MarkingType.Input source={'markingType'} />
    <TextInput source={'participantInn'} />
    <TextInput source={'producerInn'} />
    <productionTypeInput.Input source={'productionType'} />
    <TextInput source={'production_date'} />
    <TextInput source={'guids'} />
    <TextInput source={'docnums'} />
  </Filter>
);

const ChildrenPButton = (props) => {
  return (
    <InputP.LinkToList
      label={`resources.${resourceConfig.name}.inputP`}
      filter={{
        overEntityIds: props.record.id,
      }}
    />
  );
};

// const CheckButton = (props) => {
//     return (
//         <inputCheck.OpenButton params={{ inputId: props.record.id }}/>
//     );
// }

const ResourceActions = ({
  bulkActions,
  basePath,
  currentSort,
  displayedFilters,
  exporter,
  filters,
  filterValues,
  onUnselectItems,
  resource,
  selectedIds,
  showFilter,
  total,
  translate,
}) => (
  <Toolbar>
    {bulkActions &&
      React.cloneElement(bulkActions, {
        basePath,
        filterValues,
        resource,
        selectedIds,
        onUnselectItems,
      })}
    {filters &&
      React.cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: 'button',
      })}
    <documentImport.OpenButton params={{ docType: 'INPUT' }} />
    <CreateButton basePath={basePath} to={`${basePath}/create`} />
    <ExportDocButton
      disabled={total === 0}
      resource={resource}
      sort={currentSort}
      filter={filterValues}
      exporter={exporter}
    />
  </Toolbar>
);

const ResourceList = withStyles(listStyles)(({ classes, ...props }) => (
  <List
    {...props}
    filters={<ResourceListFilter />}
    sort={{ field: 'id', order: 'DESC' }}
    actions={<ResourceActions />}
    bulkActionButtons={<ResourceBulkActionButtons />}
    exporter={exporter}
    pagination={<PostPagination />}>
    <Datagrid rowStyle={documentRowStyle}>
      <TextField source={'id'} />
      <TextField source={'producerInn'} />
      <TextField source={'participantInn'} />
      <TextField source={'tradeParticipantInn'} />
      <MarkingType.Field source={'markingType'} />
      <TextField source={'docnum'} />
      <TextField source={'error'} />
      <TextField source={'guid'} />
      <docType.Field source={'docType'} />
      <DateField source={'processedDate'} />
      <docCheckStatus.Field source={'checkStatus'} />
      <TextField source={'senderTaxNumber'} />

      <errorModel.LinkToRelatedList type={'INPUT'} />
      <objectSendModel.LinkToRelatedList type={'INPUT'} />
      <SendOrderButton />
      {/* <CheckButton /> */}
      <ChildrenPButton />
      <EditButton />
    </Datagrid>
  </List>
));

const ResourceTitle = translate(({ record, translate }) => (
  <span>
    {translate(`resources.${resourceConfig.name}.name`, { smart_count: 1 })} &quot;{record.name}
    &quot;
  </span>
));

const ResourceCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source={'actionId'} />
      {/* <TextInput source={'companyUniqName'} /> */}
      <TextInput source={'creatorUsername'} />
      <TextInput source={'currency'} />
      <TextInput source={'customsCode'} />
      <TextInput source={'decisionCode'} />
      <DateInput
        source={'declarationDate'}
        label={`resources.${resourceConfig.name}.fields.declarationDate`}
      />
      <TextInput source={'declarationNumber'} />
      <directionType.Input source={'direction'} />
      <docStatus.Input source={'docStatus'} />
      <docType.Input source={'docType'} />
      <TextInput source={'docnum'} />
      <TextInput source={'documentId'} />
      <docLinkType.Input source={'documentLinkType'} />
      <NumberInput source={'documentLinkId'} />
      <docStatusSystem.Input source={'documentSystemStatus'} />
      <TextInput source={'error'} />
      <TextInput source={'guid'} />
      <markingType.Input source={'markingType'} />
      <TextInput source={'ownerInn'} />
      <TextInput source={'participantInn'} />
      <DateInput
        source={'processedDate'}
        label={`resources.${resourceConfig.name}.fields.processedDate`}
      />
      <TextInput source={'producerInn'} />
      <TextInput source={'productionOrder'} />
      <productionTypeInput.Input source={'productionType'} />
      <DateInput
        source={'production_date'}
        label={`resources.${resourceConfig.name}.fields.production_date`}
      />
      <TextInput source={'receiverId'} />
      <TextInput source={'requestId'} />
      <markingStatus.Input source={'status'} />
      <TextInput source={'subjectId'} />
      <TextInput source={'tradeParticipantInn'} />

      <TextInput source={'countryOksm'} />
      <TextInput source={'exporterName'} />
      <DateInput
        source={'importDate'}
        label={`resources.${resourceConfig.name}.fields.importDate`}
      />
      <DateInput
        source={'primaryDocumentDate'}
        label={`resources.${resourceConfig.name}.fields.primaryDocumentDate`}
      />
      <TextInput source={'primaryDocumentNumber'} />
      <DateInput
        source={'productReceivingDate'}
        label={`resources.${resourceConfig.name}.fields.productReceivingDate`}
      />
      <TextInput source={'vsdNumber'} />
      <TextInput source={'senderTaxNumber'} />
      {/* <BooleanInput source={'runningBefore'} /> */}
      {/* <TextInput source={'ismpDocType'} /> */}
    </SimpleForm>
  </Create>
);

const ResourceEdit = (props) => (
  <Edit redirect={null} undoable={false} title={<ResourceTitle />} {...props}>
    <SimpleForm redirect={false}>
      <TextInput source={'actionId'} />
      {/* <TextInput source={'companyUniqName'} /> */}
      <TextInput source={'creatorUsername'} />
      <TextInput source={'currency'} />
      <TextInput source={'customsCode'} />
      <TextInput source={'decisionCode'} />
      <DateInput
        source={'declarationDate'}
        label={`resources.${resourceConfig.name}.fields.declarationDate`}
      />
      <TextInput source={'declarationNumber'} />
      <directionType.Input source={'direction'} />
      <docStatus.Input source={'docStatus'} />
      <docType.Input source={'docType'} />
      <TextInput source={'docnum'} />
      <TextInput source={'documentId'} />
      <docLinkType.Input source={'documentLinkType'} />
      <NumberInput source={'documentLinkId'} />
      <docStatusSystem.Input source={'documentSystemStatus'} />
      <TextInput source={'error'} />
      <TextInput source={'guid'} />
      <markingType.Input source={'markingType'} />
      <TextInput source={'ownerInn'} />
      <TextInput source={'participantInn'} />
      <DateInput
        source={'processedDate'}
        label={`resources.${resourceConfig.name}.fields.processedDate`}
      />
      <TextInput source={'producerInn'} />
      <TextInput source={'productionOrder'} />
      <productionTypeInput.Input source={'productionType'} />
      <DateInput
        source={'production_date'}
        label={`resources.${resourceConfig.name}.fields.production_date`}
      />
      <TextInput source={'receiverId'} />
      <TextInput source={'requestId'} />
      <markingStatus.Input source={'status'} />
      <TextInput source={'subjectId'} />
      <TextInput source={'tradeParticipantInn'} />

      <TextInput source={'countryOksm'} />
      <TextInput source={'exporterName'} />
      <DateInput
        source={'importDate'}
        label={`resources.${resourceConfig.name}.fields.importDate`}
      />
      <DateInput
        source={'primaryDocumentDate'}
        label={`resources.${resourceConfig.name}.fields.primaryDocumentDate`}
      />
      <TextInput source={'primaryDocumentNumber'} />
      <DateInput
        source={'productReceivingDate'}
        label={`resources.${resourceConfig.name}.fields.productReceivingDate`}
      />
      <TextInput source={'vsdNumber'} />
      <TextInput source={'senderTaxNumber'} />
      <BooleanInput source={'sentToSoa'} />
    </SimpleForm>
  </Edit>
);

const ResourceReferenceField = (props) => (
  <ReferenceField reference={resourceConfig.name} {...props}>
    <TextField source={'id'} />
  </ReferenceField>
);

const ResourceReferenceArrayField = (props) => (
  <ReferenceArrayField reference={resourceConfig.name} {...props}>
    <SingleFieldList>
      <ChipField source={'id'} />
    </SingleFieldList>
  </ReferenceArrayField>
);

const ResourceReferenceInput = (props) => (
  <ReferenceInput reference={resourceConfig.name} {...props}>
    <SelectInput optionText={'id'} />
  </ReferenceInput>
);

const ResourceReferenceArrayInput = (props) => (
  <ReferenceArrayInput reference={resourceConfig.name} {...props}>
    <SelectArrayInput optionText={'id'} />
  </ReferenceArrayInput>
);

export default {
  Icon: ResourceIcon,
  List: ResourceList,
  Title: ResourceTitle,
  Create: ResourceCreate,
  Edit: ResourceEdit,
  Field: ResourceReferenceField,
  ArrayField: ResourceReferenceArrayField,
  Input: ResourceReferenceInput,
  ArrayInput: ResourceReferenceArrayInput,
  LinkToList,

  name: resourceConfig.name,
  resourceConfig: {
    name: resourceConfig.name,
    list: ResourceList,
    edit: ResourceEdit,
    create: ResourceCreate,
    icon: ResourceIcon,
  },
  menuConfig: {
    name: resourceConfig.name,
    icon: ResourceIcon,
  },
  locales: resourceLocales,
  restProviderResolve: {
    name: resourceConfig.name,
    apiService: resourceConfig.apiService,
    basePath: resourceConfig.apiPath,
    schema: {
      declarationDate: {
        type: 'dateTime',
      },
      processedDate: {
        type: 'dateTime',
      },
      production_date: {
        type: 'dateTime',
      },
      importDate: {
        type: 'dateTime',
      },
      primaryDocumentDate: {
        type: 'dateTime',
      },
      productReceivingDate: {
        type: 'dateTime',
      },
    },
    filters: {
      declarationDate: {
        type: 'dateTime',
      },
      processedDate: {
        type: 'dateTime',
      },
      production_date: {
        type: 'dateTime',
      },
      importDate: {
        type: 'dateTime',
      },
      primaryDocumentDate: {
        type: 'dateTime',
      },
      productReceivingDate: {
        type: 'dateTime',
      },
    },
  },
};
